import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import type { IdleConfigData, IdleRateBracket } from '../../../idle-reward.ts';

// idle_config — single-row(id=1) 방치 보상 설정. rate_brackets/multipliers/quick_gain 는
// JSONB 컬럼(내부 camelCase 키 그대로 저장) → kind:'json' 필드로 통째 보존.
export const IdleConfigSchema = defineSchema({
  name: 'serverIdleConfigs',
  fields: [
    ['id', 'number'],
    ['rateBrackets', { kind: 'json' }],
    ['capMinutes', 'number'],
    ['capMinutesPassPerk', 'number'],
    ['capMinutesBoostPack', 'number'],
    ['sapphireFullMinutes', 'number'],
    ['multipliers', { kind: 'json' }],
    ['quickGain', { kind: 'json' }],
    ['guestMaxStage', 'number'],
    ['minClaimMinutes', 'number'],
  ],
  lookupKeys: ['id'],
});

export interface RawIdleConfigRow {
  id: number;
  rate_brackets: IdleRateBracket[];
  cap_minutes: number;
  cap_minutes_pass_perk: number;
  cap_minutes_boost_pack: number;
  sapphire_full_minutes: number;
  multipliers: IdleConfigData['multipliers'];
  quick_gain: IdleConfigData['quickGain'];
  guest_max_stage: number;
  min_claim_minutes: number;
}

export function idleConfigFromRaw(row: RawIdleConfigRow): IdleConfigData {
  return {
    id: row.id,
    rateBrackets: row.rate_brackets,
    capMinutes: row.cap_minutes,
    capMinutesPassPerk: row.cap_minutes_pass_perk,
    capMinutesBoostPack: row.cap_minutes_boost_pack,
    sapphireFullMinutes: row.sapphire_full_minutes,
    multipliers: row.multipliers,
    quickGain: row.quick_gain,
    guestMaxStage: row.guest_max_stage,
    minClaimMinutes: row.min_claim_minutes,
  };
}

registerCategorySchema('serverIdleConfigs', IdleConfigSchema);
